module.exports = __webpack_public_path__ + "static/media/arrow-alt-up.7da07382.svg";